/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventOrganizer } from '../../models/event-organizer';

export interface SearchOrganizer$Params {
  search: string;
}

export function searchOrganizer(http: HttpClient, rootUrl: string, params: SearchOrganizer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EventOrganizer>>> {
  const rb = new RequestBuilder(rootUrl, searchOrganizer.PATH, 'get');
  if (params) {
    rb.path('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EventOrganizer>>;
    })
  );
}

searchOrganizer.PATH = '/rest/search-organizer/{search}';
